import './DadosConta.css';
import { useState, useEffect, useRef } from 'react';
import { useCookies } from "react-cookie";
import { HiOutlineLockClosed } from "react-icons/hi";
import { useNavigate } from 'react-router-dom'
import EtapaDadosConta from '../../Banners/EtapaDadosConta/EtapaDadosConta'
import BannerDadosContaPhone from '../../Banners/BannerDadosContaPhone/BannerDadosContaPhone.js'
import Input from '../../Input/input';
import Button from '../../Button/button';
import axios from 'axios';
import api from '../../../services/api.js';
import Loading from '../../Loading/Loading.js'

import imagemContaLuz from '../../../services/contaLuzImagem.js';

function DadosConta() {    
    const getSessionUf = sessionStorage.getItem("sessionUf")
    const getSessionCidade = sessionStorage.getItem("sessionCidade")

    const image = imagemContaLuz(getSessionUf, getSessionCidade)
    console.log(image);

    const [cookies] = useCookies(['__gtm_campaign_url']);
    const [fieldsValidity, setFieldsValidity] = useState([]);
    const [isChecked, setIsChecked] = useState(true)
    const [payload, setPayload] = useState([]);
    const navigate = useNavigate();
    const [isShowLoading, setShowLoading] = useState(false);
    const encode_data = sessionStorage.getItem("encode_data")
    
    const [faturaBase64, setFaturaBase64] = useState("");
    const [faturaName, setFaturaName] = useState("Clique em importar imagem");
    
    function convertCookie(cookieUrl) {
        const rawParams = cookieUrl?.split("?")?.[1]?.split("&");
        const wantedParams = [
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "utm_id",
            "utm_content",
            "utm_term",
            "gclid",
            "fbclid",
            "aff_click_id",
        ];

        const cleanParams = {}

        if (rawParams) {
            for (const rawParam of rawParams) {
                const [key, value] = rawParam.split("=");
                if (key === 'aff_click_id') {
                    axios.get(`https://api.vsboon.com.br/reward/delivery/savvi?aff_click_id=${value}&action_type=Inapp`)
                        .then(() => {
                            //   console.log('deu certo')
                        })
                        .catch(() => {
                            //   console.log('deu errado')
                        })
                }
                if (key && value && wantedParams.includes(key)) {
                    cleanParams[key] = value;
                }
            }
            return cleanParams;
        }
        return {};
    }



    const onChange = e => {
        const files = e.target.files;
        const file = files[0];
        setFaturaName(file.name);
        getBase64(file);
      };
    
      const onLoad = fileString => {
        // console.log(fileString);
        setFaturaBase64(fileString);
      };
    
      const getBase64 = file => {
        let reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
          onLoad(reader.result);
        };
      };


    let buttonContinuar = document.querySelector(".btnContinuar");
    let btnContinuar = "btnContinuar"
    let btnVoltar = "btnVoltar"
    async function handleSubmit(e) {
        e.preventDefault();
        const errors = handleOnBlur(payload, "submit");

        if (errors.length === 0) {
            const code_instalacao = payload.CodInstalacao
            const code_pn = payload.Pn
            const fatura = faturaBase64
            const cookieParams = convertCookie(cookies.__gtm_campaign_url);
            const sendbackend = {
                code_instalacao,
                code_pn,
                fatura,

                utm_campaign: (cookieParams.utm_campaign || ""),
                utm_medium: (cookieParams.utm_medium || ""),
                utm_source: (cookieParams.utm_source || ""),
                utm_id: (cookieParams.utm_id || ""),
                utm_content: (cookieParams.utm_content || ""),
                utm_term: (cookieParams.utm_term || ""),
                gclid: (cookieParams.gclid || ""),
                fbclid: (cookieParams.fbclid || ""),
                aff_click_id: (cookieParams.aff_click_id || ""),
            }
            
            const JsonArray = JSON.stringify(sendbackend)
            const json_obj = JSON.parse(JsonArray)

            console.log(json_obj);

            setShowLoading(true);

            api.put(`/crefaz/update/${encode_data}`, json_obj, {
            },{

            })
            .then((response) => {
                console.log(response.data)
                navigate("/dados-pessoais");
                setShowLoading(false);
            })
            .catch((err) => {
                console.log("Erro", err)
                setShowLoading(false);
            })
        } 
    }
    const handleOnBlur = (e, prop) => {
        const errors = [];
        if ((prop === "CodInstalacao" && !e?.target?.value) || (prop === "submit" && !e?.CodInstalacao)) {
            errors.push({
                prop: "CodInstalacao",
                errorMessage: "Insira o código de instalação"
            })
        }

        if ((prop === "Pn" && !e?.target?.value) || (prop === "submit" && !e?.Pn)) {
            errors.push({
                prop: "Pn",
                errorMessage: "Insira o PN"
            })
        }
       
        setFieldsValidity(errors)

        return errors;
    }

    const handleChangeInputs = (value, prop) => {
        setPayload({ ...payload, [prop]: value })
    }

    const infoShow = () => {
        setIsShow(true);
    }

    const infoShow2 = () => {
        setIsShow2(true);
    }

    const infoHide2= () => {
        setIsShow2(!isShow2);
        console.log("infoHide...")
    }

    const infoHide= () => {
        setIsShow(!isShow);
        console.log("infoHide...")
    }

    const [isShow, setIsShow] = useState(false);
    const [isShow2, setIsShow2] = useState(false);

    return (
        <div className="home">
            {isShowLoading && <Loading />}
            <EtapaDadosConta />
            <BannerDadosContaPhone />
            <form
                className='container2'
                onSubmit={handleSubmit}
            >
                <div className='form'>
                    <div className='titleform'>
                        <h4 className='titleMob'>Insira as informações contidas em sua conta de energia</h4>
                    </div>
                    <div className='spaceform'></div>

                    <img className='contaLuz' src={imagemContaLuz(getSessionUf, getSessionCidade)} />


                    <div className='contaLuzObs'>Algumas faturas estão vindo sem o campo PN. Neste caso preencher com a sequência: 123456789</div>

                    <div className='Input-form'>
                        <div className='group'>
                            <label className='label'><b>Seu Código</b> (instalação)</label>
                            <Input
                                onChange={(e) => handleChangeInputs(e.target.value, "CodInstalacao")}
                                onKeyDown={infoShow2}
                                value={payload.CodInstalacao}
                                name="CodInstalacao"
                                type="text"
                                placeholder='Digite o cógigo de instalação'
                                length="9"
                                error={fieldsValidity}
                                handleOnBlur={handleOnBlur}
                            />
                        </div>
                        <div className='spaceform'></div>

                        <div className='group'>
                            <label className='label'><b>PN</b></label>
                            <Input
                                onChange={(e) => handleChangeInputs(e.target.value, "Pn")}
                                onKeyDown={infoShow}
                                value={payload.Pn}
                                name="Pn"
                                type="text"
                                placeholder='PN'
                                length="9"
                                error={fieldsValidity}
                                handleOnBlur={handleOnBlur}
                            />
                        </div>
                        

                        <div className='contaLuzText'>Por favor, tire uma foto da sua fatura de energia e anexe</div>
                        <div className='contaLuzTextInfo'>Atenção: faça a foto em local com boa iluminação.</div>


                        <div className='groupUpload'>{faturaName}</div>
                        
                        <div class="custom-file">
                            <input name='imagemUpload' type="file" class="custom-file-input" id="customFile"  onChange={onChange}/>
                            <label class="custom-file-input" for="customFile">Importar Imagem</label>
                        </div>

                      
                        <div className='spaceform'></div>

                        <Button
                            message='CONTINUAR'
                            className={btnContinuar}
                            isChecked={isChecked}
                        />

                        <button
                            className={btnVoltar}
                            cursor='pointer'
                            onClick={() => navigate("/simulacao")}>
                            VOLTAR
                        </button>

                        <div className='space1'></div>
                    </div>


                </div>
            </form >
        </div >
    );
}

export default DadosConta;